import type { Components, Theme } from '@mui/material/styles';

export function surfaceOverrides(theme: Theme): Components<Theme> {
  const mobile = theme.breakpoints.down('sm');

  return {
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: { backgroundImage: 'none', borderRadius: 4 },
        outlined: { borderColor: theme.palette.divider },
      },
    },
    MuiCard: {
      defaultProps: { variant: 'outlined', elevation: 0 },
      styleOverrides: {
        root: {
          borderRadius: 4,
          boxShadow: 'none',
          borderColor: theme.palette.divider,
          backgroundColor: theme.palette.background.paper,
          backgroundImage: 'none',
          transition: `box-shadow 150ms ${theme.transitions.easing.easeOut}, transform 150ms ${theme.transitions.easing.easeOut}`,
          // .card-interactive:hover → shadow + translateY(-1px)
          // Predisposizione: applicare la classe alle card cliccabili
          // quando verranno refactorate (PR future, non ora).
          '&.card-interactive:hover': {
            boxShadow:
              theme.palette.mode === 'dark'
                ? '0 2px 4px rgba(0,0,0,0.45), 0 4px 8px rgba(0,0,0,0.55)'
                : '0 2px 4px rgba(16,24,40,0.04), 0 4px 8px rgba(16,24,40,0.06)',
            transform: 'translateY(-1px)',
          },
          '@media (prefers-reduced-motion: reduce)': {
            transition: 'none',
            '&.card-interactive:hover': { transform: 'none' },
          },
        },
      },
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: { variant: 'h4' },
        subheaderTypographyProps: { variant: 'caption', color: 'text.secondary' },
      },
      styleOverrides: {
        root: {
          padding: theme.spacing(3),
          [mobile]: { padding: theme.spacing(4) },
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3),
          '&:last-child': { paddingBottom: theme.spacing(3) },
          [mobile]: {
            padding: theme.spacing(4),
            '&:last-child': { paddingBottom: theme.spacing(4) },
          },
        },
      },
    },
    MuiDivider: {
      styleOverrides: { root: { borderColor: theme.palette.divider } },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          border: '1px solid',
          alignItems: 'center',
          padding: theme.spacing(2, 3),
          [mobile]: { padding: theme.spacing(3, 4) },
        },
        standardSuccess: {
          backgroundColor: 'rgba(34, 197, 94, 0.1)',
          borderColor: theme.palette.success.main,
          color: theme.palette.text.primary,
        },
        standardWarning: {
          backgroundColor: 'rgba(245, 158, 11, 0.1)',
          borderColor: theme.palette.warning.main,
          color: theme.palette.text.primary,
        },
        standardError: {
          backgroundColor: 'rgba(239, 68, 68, 0.1)',
          borderColor: theme.palette.error.main,
          color: theme.palette.text.primary,
        },
        standardInfo: {
          backgroundColor: 'rgba(59, 130, 246, 0.1)',
          borderColor: theme.palette.info.main,
          color: theme.palette.text.primary,
        },
      },
    },
    MuiSkeleton: {
      defaultProps: { animation: 'wave' },
      styleOverrides: {
        root: {
          borderRadius: 6,
          backgroundColor: theme.palette.mode === 'light' ? 'rgba(16,24,40,0.06)' : 'rgba(255,255,255,0.08)',
        },
      },
    },
    MuiDrawer: {
      defaultProps: { transitionDuration: { enter: 250, exit: 250 } },
      styleOverrides: {
        paper: { backgroundImage: 'none', borderRadius: 0 },
      },
    },
  };
}
